import { Measurement } from '@/types/meters'

export const parseFirstMeasurementAggOrValue = (measurement: Measurement): number => {
    const firstKey = Object.keys(measurement)[0] as keyof Omit<Measurement, 'timestamp'>
    if (!firstKey) {
        throw new Error('No value found in measurement')
    }
    return measurement[firstKey] as number
}
